import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { UiUtil } from "../../util/UiUtil";
import { PageContext } from "../../service/PageContext";

export class ScrollToTopButton extends Component {

    constructor(element: HTMLElement, pageContext: PageContext) {
        super(element, pageContext);
    }

    public async init(): Promise<void> {
        window.addEventListener("scroll", () => this.scrollFunction())
        this._element.addEventListener("click", () => UiUtil.scrollToTop())
    }

    private scrollFunction(): void {
        if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
            this._element.style.display = "block";
        } else {
            this._element.style.display = "none";
        }
    }
}



ComponentFactory.registerComponent("ScrollToTopButton",
    ScrollToTopButton);
